export default function Email() {
  return (
    <a className='inline text-orange-300' href='mailto: waldorfcentr@list.ru'>
      waldorfcentr@list.ru
    </a>
  )
}
